var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "spacer-top-big" },
    [
      _c(
        "b-col",
        { attrs: { "offset-lg": "3", lg: "6" } },
        [
          _c(
            "b-form",
            [
              _c(
                "b-card",
                { staticClass: "card-small card-regform" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "text-center",
                      attrs: { slot: "header" },
                      slot: "header"
                    },
                    [
                      _c("img", {
                        staticClass: "form-logo",
                        attrs: { src: require("@/assets/img/logo_nedgia.png") }
                      }),
                      _vm._v(" "),
                      _c(
                        "h1",
                        {
                          staticClass: "form-headertext",
                          staticStyle: { color: "#004072" }
                        },
                        [_vm._v(_vm._s(_vm.title))]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("default"),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "text-center",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  })
                ],
                2
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Pages/Login/MainLogin.vue?vue&type=template&id=7f21a9ff&
// module id = null
// module chunks = 